/**
 * @module Rating
 */

import Component from '../Component';
import './styles.css';

/**
 * Звёзды рейтинга.
 */
export default class Rating extends Component {
    static className = 'rating';
}
